var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "component-form" },
    [
      _c("p", { staticClass: "text big bold" }, [
        _vm._v(
          "Select your HSYLC site preference here. Please do not select any site that you are unable to go."
        )
      ]),
      _c("div", { staticClass: "inp-flex mt-30" }, [
        _c(
          "div",
          { staticClass: "inp-wrap" },
          [
            _c("Select", {
              attrs: {
                label: "First Preference",
                placeholder: "",
                isVerific: false,
                startVerific: false,
                value: _vm.value.first,
                options: _vm.OPTIONS
              },
              on: {
                input: function($event) {
                  return _vm.handleInput($event, "first")
                }
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "inp-flex mt-30" }, [
        _c(
          "div",
          { staticClass: "inp-wrap" },
          [
            _c("Select", {
              attrs: {
                label: "Second Preference",
                placeholder: "",
                isVerific: false,
                startVerific: false,
                value: _vm.value.second,
                options: _vm.OPTIONS
              },
              on: {
                input: function($event) {
                  return _vm.handleInput($event, "second")
                }
              }
            })
          ],
          1
        )
      ]),
      _c("div", { staticClass: "inp-flex mt-30" }, [
        _c(
          "div",
          { staticClass: "inp-wrap" },
          [
            _c("Select", {
              attrs: {
                label: "Third Preference",
                placeholder: "",
                isVerific: false,
                startVerific: false,
                value: _vm.value.third,
                options: _vm.OPTIONS
              },
              on: {
                input: function($event) {
                  return _vm.handleInput($event, "third")
                }
              }
            })
          ],
          1
        )
      ]),
      _c(
        "Button",
        { staticClass: "btn-submit", on: { click: _vm.handleClickSubmit } },
        [_vm._v("Submit")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }